<template>
  <v-btn data-cy="router-back-btn" icon fab small @click="$router.back()">
    <v-icon class="blue-grey--text text--lighten-2">mdi-arrow-left</v-icon>
  </v-btn>
</template>

<script>
export default {}
</script>
